import React from 'react';
import BulkUploadButtons from 'components/BulkUploadButtons';
import useGate from 'hooks/useGate';
import useCheckAccess from 'hooks/useCheckAccess';
import { gateNames } from 'constants/statsig';

type RateSettingsBulkUploadActionsProps = {
  accessResource: string;
  downloadUrl: string;
  uploadUrl: string;
};

const RateSettingsBulkUploadActions = ({
  accessResource,
  downloadUrl,
  uploadUrl,
}: RateSettingsBulkUploadActionsProps) => {
  const checkAccess = useCheckAccess();
  const { value: blockCreateRateSettings } = useGate(gateNames.blockCreateNewRateSettings);
  const hasAccess = checkAccess('actions', accessResource, 'import');
  const canImport = hasAccess && !blockCreateRateSettings;

  if (!canImport) {
    return null;
  }

  return <BulkUploadButtons downloadUrl={downloadUrl} uploadUrl={uploadUrl} />;
};

export default RateSettingsBulkUploadActions;
